(() => {
  if (customElements.get('quickview-modal')) {
    return;
  }

  class QuickView extends ModalDialog {
    constructor() {
      super();

      this.sliderContainer = this.querySelector('[data-slider]');
      this.slider = null;
      this.sliderOptions = {};

      document.body.appendChild(this);
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      if (!this.sliderContainer) {
        return;
      }

      this.sliderOptions = {
        slidesPerView: 'auto',
        spaceBetween: 8,
        centeredSlides: true,
        loop: true,
        navigation: {
          prevEl: this.querySelector('.swiper-arrow--prev'),
          nextEl: this.querySelector('.swiper-arrow--next'),
        },
      };

      this.slider = new Swiper(this.sliderContainer, this.sliderOptions);
    }
  }

  customElements.define('quickview-modal', QuickView);
})();
